import FacebookIcon from "../../../../../../assets/icons/FacebookIcon"
import InstagramIcon from "../../../../../../assets/icons/InstagramIcon"
import PlusIcon from "~icons/eva/plus-outline"
import styles from "./styles.module.scss"

export const SocialMediaButton = ({
  socialMediaName,
  onClick,
  isDisabled = false,
  label = "",
}: {
  socialMediaName: "facebook" | "instagram"
  onClick: () => void
  isDisabled?: boolean
  label?: string
}) => {
  return (
    <button className={styles.socialMediaButton} disabled={isDisabled} onClick={onClick}>
      <div className={styles.headingRow}>
        {socialMediaName === "facebook" ? <FacebookIcon /> : <InstagramIcon />}
        <p className={styles.headingRowText}>
          {socialMediaName === "facebook" ? "Facebook" : "Instagram"}
        </p>
      </div>
      <div className={styles.content}>
        {label ? (
          <p className={styles.contentText}>{label}</p>
        ) : (
          <div className={styles.connectRow}>
            <PlusIcon className={styles.connectRowIcon} />
            <p className={styles.connectRowText}>Connect page</p>
          </div>
        )}
      </div>
      {isDisabled ? (
        <div className={styles.overlay}>
          <p className={styles.overlayText}>Coming soon...</p>
        </div>
      ) : null}
    </button>
  )
}
